var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', [_c('div', {
    staticClass: "row form-group "
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.client')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client),
      expression: "client"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "client"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.client = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.clientSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.clientPlaceholder')))]), _vm._v(" "), _vm._l((_vm.listClientData), function(client_obj) {
    return _c('option', {
      domProps: {
        "value": client_obj.clientid
      }
    }, [_vm._v(" " + _vm._s(client_obj.clientname))])
  })], 2)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.systemLoginCheck && !_vm.warehouseLoginCheck) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.warehouse')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.warehouse),
      expression: "warehouse"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "warehouse"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.warehouse = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeswarehouse]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.warehousePlaceholder')))]), _vm._v(" "), _vm._l((_vm.listWarehouseData), function(warehouse_obj) {
    return _c('option', {
      domProps: {
        "value": warehouse_obj.warehouseid
      }
    }, [_vm._v(_vm._s(warehouse_obj.warehousename))])
  })], 2)])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cameraApp.selectCamera')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cameralist),
      expression: "cameralist"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cameralist"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cameralist = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.cameraSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('cameraApp.selectCameraPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.cameras), function(client_obj) {
    return _c('option', {
      domProps: {
        "value": client_obj.deviceId
      }
    }, [_vm._v(" " + _vm._s(client_obj.label))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cameraApp.selectResolution')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resolution),
      expression: "resolution"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "resolution"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.resolution = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.selectresolution]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.resolutionlist[1].name))]), _vm._v(" "), _vm._l((_vm.resolutionlist), function(res) {
    return _c('option', {
      domProps: {
        "value": res.resolution
      }
    }, [_vm._v(" " + _vm._s(res.name))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cameraApp.selectImageType')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imagetype),
      expression: "imagetype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "imagetype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.imagetype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('cameraApp.selectImageType')))]), _vm._v(" "), _vm._l((_vm.imagetypearray), function(res) {
    return _c('option', {
      domProps: {
        "value": res.imagetype
      }
    }, [_vm._v(" " + _vm._s(res.imagetype))])
  })], 2)])], 1), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cameraApp.rejectReason')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rejectreason),
      expression: "rejectreason"
    }],
    attrs: {
      "id": "rejectreason",
      "name": "rejectreason",
      "type": "text",
      "placeholder": _vm.$t('errorLogReport.description')
    },
    domProps: {
      "value": (_vm.rejectreason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rejectreason = $event.target.value
      }
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.notcam == true) ? _c('h6', [_vm._v(_vm._s(_vm.$t('cameraApp.chooseCamera')))]) : _vm._e(), _vm._v(" "), (_vm.notcam == false) ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "10px !important",
      "margin-bottom": "20px !important"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.checkbtn
    },
    on: {
      "click": function($event) {
        _vm.stopcam()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cameraApp.startCam')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.notcheckbtn
    },
    on: {
      "click": function($event) {
        _vm.startbtn()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cameraApp.stopCam')))])]) : _vm._e(), _vm._v(" "), _c('web-cam', {
    ref: "test",
    attrs: {
      "height": "300",
      "width": "350",
      "autoplay": "autoplay",
      "screenshotFormat": "image/jpeg",
      "selectFirstDevice": _vm.selectFirstDevice,
      "playsinline": "playsinline",
      "resolution": _vm.setresolution
    },
    on: {
      "cameras": _vm.camerass
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row form-group "
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "10px !important"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cameraApp.srID')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.srrto),
      expression: "srrto"
    }],
    ref: "text",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "text",
      "name": "text"
    },
    domProps: {
      "value": (_vm.srrto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.srrto = $event.target.value
      }
    }
  })])], 1), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 "
  }, [_c('b-button', {
    staticClass: "glass",
    staticStyle: {
      "margin-top": "10px !important"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.getimages()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('product.search')))])], 1), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "10px !important"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cameraApp.imageUpload')))]), _vm._v(" "), _c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "id": "file",
      "name": "csv"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.invalid_img_flag == true) ? _c('label', {
    staticClass: "text-danger",
    attrs: {
      "for": "file"
    }
  }, [_vm._v(_vm._s(_vm.$t('cameraApp.invalidImage')))]) : _vm._e(), _vm._v(" "), (_vm.client != '' && _vm.rejectreason != '' && _vm.imagetype != '' && _vm.vaildimg == true) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.upload()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.saveBtn')))]) : _vm._e()]), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group ",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.client != '' && _vm.rejectreason != '' && _vm.imagetype != '' && _vm.capture == false) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.capturebtn()
      }
    },
    model: {
      value: (_vm.capture),
      callback: function($$v) {
        _vm.capture = $$v
      },
      expression: "capture"
    }
  }, [_vm._v(_vm._s(_vm.$t('cameraApp.capture')))]) : _vm._e(), _vm._v(" "), (_vm.client != '' && _vm.rejectreason != '' && _vm.imagetype != '' && _vm.capture == true) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cameraApp.retake')))]) : _vm._e(), _vm._v(" "), (_vm.client != '' && _vm.rejectreason != '' && _vm.imagetype != '' && _vm.capture == true) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.saveBtn')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  })])])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9c77a19a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c77a19a","hasScoped":false}!./src/views/components/cameraapp/cameraapp.component.html
// module id = 1977
// module chunks = 0